'use strict';

angular.module('Directives').directive('ngTimepicker', function($timeout) {
    return {
        'restrict': 'A',
        'scope': {
            ngModel: '='
        },
        'link': function linkingFunction($scope, element, attr) {

            $timeout(function(){
                element.timepicker();
            });
            $scope.$watch('ngModel', function(o, n) {
                $timeout(function() {
                    element.timepicker();
                });
            });
        }
    }
});


// WEBPACK FOOTER //
// ./js/directives/timepicker.js